import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { selectCurrentQueryId } from 'ducks/searches/selectors'
import { doRedirectToCollectionAndFolderById } from 'ducks/folders/operations/collections'

export const useChatLanding = () => {
  const dispatch = useDispatch()
  const currentQueryId = useSelector(selectCurrentQueryId)

  useEffect(
    () => {
      if (!currentQueryId) dispatch(doRedirectToCollectionAndFolderById())
    },
    [currentQueryId, dispatch]
  )
}
